import React, { Component } from 'react';
import PropTypes from 'prop-types';

import '../styles.css';

class InputOffArticulo extends Component {
     constructor(props) {
          super(props);
          this.state = {
               id:props.id,
               defaultValue:props.defaultValue,
          };
     }

     componentWillReceiveProps(nextProps) {
          if(this.state.id !== nextProps.id || this.state.defaultValue !== nextProps.defaultValue){
               this.setState({
                    id:nextProps.id,
                    defaultValue:nextProps.defaultValue,
               });
          }
     }

     updateValue(evt){
          evt.preventDefault();
          if(this.props.valueChanged && this.props.disabled == false){
               this.setState(
                    {defaultValue:evt.target.value},
                    ()=>this.props.valueChanged(this.state.id, this.state.defaultValue)
               );
          }
     }

     SelectAll(evt){
          evt.preventDefault();
          evt.target.select();
     }

     render() {
          return (
               <input min="0" max="100" disabled={this.props.disabled} type="number" className="InputOffArticulo-Input" onClick={(evt)=>this.SelectAll(evt)} value={this.state.defaultValue} onChange={(evt) => this.updateValue(evt) }/>
          );
     }
}

export default InputOffArticulo;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Ofertas/ModalOfertas/InputOffArticulo.js